/* Wrapper around Raphael text path used to make the bottom text path */
var Util = require('../../../../../FV/util');
var moment = require('moment');
var fvChannel = require('glRadio').channel('FV');

/* note: cTime is null for new */

module.exports = function(paper, opts) {

    return paper.print(
        opts.x,
        opts.y,
        deriveTxt(opts.cUsr, opts.cTime), //null for new
        paper.getFont(opts.font),
        parseFloat(opts.fontSize)
    ).attr(opts.attrs);

    /* note: this implies new -- for others take from note model if not a concatentated path -- could put on model */
    /* latter condition for NEW shapes */
    function deriveTxt(cUsr, cTime) {

        return Util.deriveInitials(cUsr) + '-' + cUsr + '\n' +
            moment(cTime ? cTime : undefined).format( fvChannel.request('settings').DT_TIME_FMT_AMPM_SPACE_BF_CAPS_STR ) + ' ' + moment.getTimeZoneAbbrevation();
    }

};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/signature/bottomText/bottomTextEl.js
 ** module id = 222
 ** module chunks = 0
 **/